import { render, staticRenderFns } from "./ClientUsage.vue?vue&type=template&id=67cb103a"
import script from "./ClientUsage.vue?vue&type=script&lang=ts"
export * from "./ClientUsage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports